import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type {
  GTMEventGlycerinButtonClick,
  GTMEventGlycerinLinkClick,
} from '@packages/tracking/src/types/events';
import type { CustomerReviewsSort } from '../../../CustomerRatingsAndReviewsPage/SortSelection/getSortParams';
import { getSortingSelectionDetailValue } from './getSortingSelectionDetailValue';

const defaults: Pick<GTMEventGlycerinButtonClick['ButtonClickData'], 'label'> = {
  label: 'Kundenbewertungen',
};

export const useCustomerRatingsTracking = () => {
  const dispatchTracking = useTracking();

  const trackSortingSelection = (sortedBy: CustomerReviewsSort) => {
    dispatchTracking<GTMEventGlycerinButtonClick>({
      event: 'ButtonClick',
      ButtonClickData: {
        ...defaults,
        category: 'Sortierung',
        detail: getSortingSelectionDetailValue(sortedBy),
      },
    });
  };

  const trackFilterByRatingValue = (ratingValue: number) => {
    dispatchTracking<GTMEventGlycerinLinkClick>({
      event: 'LinkClick',
      LinkClickData: {
        ...defaults,
        category: 'Bewertungsübersicht',
        detail: ratingValue.toString(),
      },
    });
  };

  return {
    trackSortingSelection,
    trackFilterByRatingValue,
  };
};
